import { isSameAs, isMinLength } from "Commons/Utilities/validators";

export const isMinLength6 = isMinLength(6);
export const verifyPassword = isSameAs("password");
